import { render, staticRenderFns } from "./EditGroupStageStandingTournament.vue?vue&type=template&id=040c9c90"
import script from "./EditGroupStageStandingTournament.vue?vue&type=script&lang=js"
export * from "./EditGroupStageStandingTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports